import { Controller } from "@hotwired/stimulus"

// Makes each bar or point of the Chartkick chart inside the element open the
// list behind it (TilesHelper#chart_links). urls holds one URL per data point,
// in the series' order. Chartkick draws the chart after its script loads, so
// the Chart.js instance is looked up until it exists. The tile also links the
// whole series in text, the keyboard way to the same lists.
export default class extends Controller {
  static values = { urls: Array }

  connect() {
    this.attempts = 0
    this.hook()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  hook() {
    const chart = this.chart()
    if (!chart) {
      if (this.attempts++ < 50) this.timer = setTimeout(() => this.hook(), 100)
      return
    }

    chart.options.onClick = (_event, elements) => {
      const url = this.urlAt(elements)
      if (url) this.visit(url)
    }
    chart.options.onHover = (event, elements) => {
      const canvas = event.native?.target
      if (canvas) canvas.style.cursor = this.urlAt(elements) ? "pointer" : "default"
    }
    chart.update("none")
  }

  chart() {
    const container = this.element.querySelector("[id]")
    const charts = window.Chartkick?.charts
    const chartkick = container && charts ? charts[container.id] : null
    return chartkick?.getChartObject?.() || null
  }

  urlAt(elements) {
    if (!elements || elements.length === 0) return null
    return this.urlsValue[elements[0].index] || null
  }

  visit(url) {
    if (window.Turbo) window.Turbo.visit(url)
    else window.location.assign(url)
  }
}
